import React, { useContext } from 'react';

import { SortableItemContext } from './SortableItem/SortableItem';

export function DragHandleDots() {
    const { attributes, listeners, ref, isDragging } = useContext(SortableItemContext);
    return (
        <button
            type="button"
            className="drag-handle__button drag-handle__dots"
            {...attributes}
            {...listeners}
            ref={ref}
            aria-pressed={isDragging}
        >
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
        </button>
    );
}
